import { TOASTTYPE, useToast } from '@/ui/Toast/Toast';
import { fetcher } from '@/utils/fetcher';
import { useQuery } from '@tanstack/react-query';
import { RETAIL_API_URL } from 'src/utils/envConfig';
import { useIntl } from 'react-intl';
import { Unit } from '@/types/Unit';

export const useCheckOnlineStatus = (unitId: Unit['id'] | undefined) => {
  const toast = useToast();
  const intl = useIntl();

  return useQuery({
    queryKey: ['online-status', unitId],
    queryFn: async () => {
      try {
        const response = await fetcher<{
          readonly success?: boolean;
          readonly isOnline?: boolean;
        }>(`${RETAIL_API_URL}/units/checkOnlineStatus?unitId=${unitId}`, {
          method: 'GET',
        });

        if (response?.success) {
          return response;
        }

        return response;
      } catch (errorInfo) {
        console.error(
          'Failed to check for the online status of one or more devices.',
          errorInfo,
        );
        toast({
          title: intl.formatMessage({
            defaultMessage:
              'Failed to check for the online status of one or more devices.',
            id: 'qM4PVY',
          }),
          mode: TOASTTYPE.Danger,
        });
        throw errorInfo;
      }
    },
    enabled: !!unitId,
    refetchInterval: 30000,
    retry: 3,
  });
};
